import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGarage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGarage"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2.85608L22 8.41163V20H2V8.41163L12 2.85608ZM8 18H16V16H8V18ZM8 14H16V12H8V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGarage;
